import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import {BATCH_STAGE} from '../../Config/appConfig';

const collapse = require('../../resource/img/collapse-default.svg');

interface BatchRecordTableViewCellProps {
    stage: string,
    row: number,
    actionCode: string,
    chassisNo: string,
    issueNo: string,
    endDate: string,
    errorMsgs: string[]
}

interface BatchRecordTableViewCellState {
    collapse: boolean
}

class BatchRecordTableViewCell extends React.Component <BatchRecordTableViewCellProps, BatchRecordTableViewCellState> {
    public constructor(props: BatchRecordTableViewCellProps) {
        super(props);
        this.state = {
            collapse: true
        };
        this.clickCollapse = this.clickCollapse.bind(this);
    }

    public clickCollapse(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            collapse: !this.state.collapse
        });
    }

    public getErrorMsg() {
        const errorMsgs = [];
        for (let i = 0; i < this.props.errorMsgs.length; i++) {
            errorMsgs.push(
                <div key={i} className="batchErrorMsg batchRecordErrorMsg">{this.props.errorMsgs[i]}</div>
            );
        }
        return <div className="cmHorCenter batchRecordErrorMsgContainer">{errorMsgs}</div>;
    }

    public render() {
        return (
            <div className="batchRecordTableViewCell">
                <div className="cmInput batchRecordTableViewCellContainer">
                    <Grid item xs={1}>
                        <div className="cmInputLabel">Row</div>
                        <div className="cmText cmTableViewCellData batchRecordTableViewCellData">{this.props.row}</div>
                    </Grid>
                    <Grid item xs={1}>
                        <div className="cmInputLabel batchRecordTableViewCellLabel">ActionCode</div>
                        <div className="cmText cmTableViewCellData batchRecordTableViewCellData">{this.props.actionCode}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className="cmInputLabel batchRecordTableViewCellLabel">ChassisNumber</div>
                        <div className="cmText cmTableViewCellData batchRecordTableViewCellData">{this.props.chassisNo}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className="cmInputLabel batchRecordTableViewCellLabel">PolicyNumber</div>
                        <div className="cmText cmTableViewCellData batchRecordTableViewCellData">{this.props.issueNo}</div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className="cmInputLabel batchRecordTableViewCellLabel">EndDate</div>
                        <div className="cmText cmTableViewCellData batchRecordTableViewCellData">
                            <span>{this.props.endDate}</span>
                            {this.props.stage === BATCH_STAGE.INVALID &&
                            <button className={`${this.state.collapse ? "cmCollapse" : ""}`} onClick={this.clickCollapse}>
                                <img src={collapse}/>
                            </button>}
                        </div>
                    </Grid>
                </div>
                {!this.state.collapse && this.getErrorMsg()}
            </div>
        );
    }
}

export default BatchRecordTableViewCell;


// WEBPACK FOOTER //
// ./src/Components/Batch/BatchRecordTableViewCell.tsx